import Vue from 'vue'

Vue.component('DateInput', () => import('@/components/common/DateInput.vue'))
Vue.component('NumericInput', () => import('@/components/common/numbers/NumericInput.vue'))
Vue.component('PercentInput', () => import('@/components/common/numbers/PercentInput.vue'))
Vue.component('PriceInput', () => import('@/components/common/numbers/PriceInput.vue'))
Vue.component('PriceCurrencyInput', () => import('@/components/common/numbers/PriceCurrencyInput.vue'))

Vue.component('I18nTextarea', () => import('@/components/common/i18n/I18NTextArea.vue'))
Vue.component('I18nText', () => import('@/components/common/i18n/I18NText.vue'))
